<template lang="pug">
.admin-super
  div {{ formMixin_message }}
  v-btn(
    :loading="formMixin_loading"
    @click="update") 更新user table
  v-btn(
    :loading="formMixin_loading"
    @click="backup") 備份DB
</template>
<script>
import { formMixin } from "@/mixins";

export default {
  name: "AdminSuper",
  mixins: [formMixin],
  methods: {
    async update() {
      const res = await this.formMixin_submit(
        [],
        "post",
        "super/update-user-table"
      );
      if (res.succeed) this.formMixin_message = "done";
    },
    async backup() {
      const res = await this.formMixin_submit([], "post", "super/backup-db");
      if (res.succeed) this.formMixin_message = "done";
    }
  }
};
</script>
